"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassNameDropDown = void 0;
const react_1 = __importStar(require("react"));
const server_1 = require("../../../../../server");
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
exports.ClassNameDropDown = react_1.default.memo(({ defaultClassId, classId, className, setClassId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [dropValue, setDropValue] = react_1.default.useState({ id: 'select', title: 'common.select' });
    const [dropList, setDropList] = react_1.default.useState([
        { id: 'select', title: 'common.select' },
    ]);
    const { data, refetch } = (0, server_1.useConferenceList)({
        status: 'booked',
    });
    (0, react_1.useEffect)(() => {
        refetch();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        const { total_count, items } = data;
        if (total_count > 0) {
            const list = items.map((item) => {
                return {
                    id: item.id,
                    title: item.title,
                };
            });
            setDropList(prevList => {
                const seen = new Set(prevList.map(item => item.id));
                const mergedList = [...prevList, ...list.filter(item => !seen.has(item.id))];
                return mergedList;
            });
            const selected = list.find(item => item.id ===
                (classId === 'select' || !classId || classId === ''
                    ? defaultClassId
                    : classId));
            if (selected)
                setDropValue(selected);
            else
                setDropValue({
                    id: classId === '' ? 'select' : classId,
                    title: className === '' ? 'common.select' : className,
                });
        }
    }, [data, defaultClassId]);
    (0, react_1.useEffect)(() => {
        setClassId(dropValue.id);
    }, [dropValue]);
    return (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.class_name')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.DropDown, { className: 'dropdown-popup', value: dropValue, list: dropList, styles: {
                    dropWrap: {
                        width: '100%',
                    },
                    itemWrap: {
                        maxHeight: 200,
                    },
                }, setDropValue: (item) => {
                    setDropValue(item);
                } }))));
});
